<template>
  <div id="app">
    <lobby-area 
      v-bind:lobbies="rooms"
      v-bind:selected_lobby="active_room"
      v-if="active_room === undefined"
      v-on:setActiveLobby="setActiveLobby">
    </lobby-area>
    <div class="gameApp" v-if="active_room != undefined">
      <div class="board">
        <div class="control-area row">
          <button v-on:click="initCards" type="button" class="btn btn-danger col-2">New Game</button>
          <div class="col">
            Game-Master View:
            <input type="checkbox" v-bind:value="isMasterView" v-on:click="toggleMasterView">
          </div>
          <div class="col">
            Dark-Mode:
            <input type="checkbox" v-bind:value="isDarkTheme" v-on:click="toggleDarkTheme">
          </div>
          <div class="float-right exit-room-icon" title="Leave Room" v-on:click="resetActiveRoom">
            <font-awesome-icon icon="times" size="2x"></font-awesome-icon>
          </div>
        </div>
        
      </div>
      <main-board v-bind:room="active_room" v-bind:info="info" v-bind:score="score" v-bind:time="time" v-bind:view="view"></main-board>
    </div> <!-- <side-board v-bind:hints-red="hints.red" v-bind:hints-blue="hints.blue"></side-board> -->
  </div>
</template>

<script>
import MainBoard from './components/Main Board/MainBoard.vue'
import LobbyArea from './components/Lobby Area/LobbyArea.vue'
// import SideBoard from './components/Side Board/SideBoard.vue'
import { cardsRef, wordsRef, roomsRef} from './firebase'
import * as CardService from './services/CardService' 
import { ViewModes, Themes } from './constants'
export default {
  name: 'App',
  components: {
    'main-board': MainBoard,
    'lobby-area': LobbyArea
    // 'side-board': SideBoard
  },
  data() {
    return {
      hints: {
        red: [
          { word: "Codename", number: 3 },
          { word: "This", number: 2 },
        ],
        blue: [
          { word: "is", number: 1 },
          { word: "C00l", number: 2 }
        ],
      },
      cards: [],
      rooms: [],
      info: {label: "Hint:", text: "Vue Rocks 9"},
      time: "0:35",
      view: ViewModes.PLAYER,
      active_room_index: undefined,
      theme: Themes.DEFAULT
    }
  },
  computed: { 
    isMasterView: function(){
      return this.view === ViewModes.MASTER;
    },
    score: function() {
      return CardService.countCards(this.active_room.cards);
    },
    isDarkTheme: function(){
      return this.theme === Themes.DARK;
    },
    active_room: function() {
      return this.rooms[this.active_room_index];
    }
  },
  firebase: {
      words: wordsRef,
      cards: cardsRef,
      rooms: roomsRef
  }, methods:{
    setView: function(newView){
      this.view = newView;
    },
    setActiveLobby: function(lobby){
      this.active_room_index = this.rooms.indexOf(lobby);
    },
    toggleMasterView: function(){
      if(this.view != ViewModes.MASTER){
        this.setView(ViewModes.MASTER);
      } else { 
        this.setView(ViewModes.PLAYER);
      }
    },
    toggleDarkTheme:  function(){
      var bodyTag = document.getElementById("body");
      if(this.theme === Themes.DARK){
        this.theme = Themes.DEFAULT;
        bodyTag.classList.remove("dark-theme");
      } else { 
        this.theme = Themes.DARK;
        bodyTag.classList.add("dark-theme");
      }
    },
    initCards: function(){
      var selectedCards = CardService.newCards(this.words, CardService.getDefaultConfig());
      roomsRef.child(this.active_room['.key']).update({cards: selectedCards});
    },
    resetActiveRoom: function(){
      this.active_room_index = undefined;
    }
   
  }
}
</script>

<style lang="stylus">
@require './styles/index'
body
  background $color__background--default
  &.dark-theme
    background $color__background--dark-theme
#app
  max-width 1100px
  margin auto
button
  font-weight bold
  color $color__black
.control-area
  padding 0 20px
  font-size 30px
  .dark-theme &
    background $color__background-board--dark-theme
.control-area input 
  width 45px
  height 45px
  transform translate(0px, 25%)
  .dark-theme &
    background $color__background-board--dark-theme
.board
  box-sizing border-box
  box-shadow 0px 4px 4px rgba(0, 0, 0, 0.5)
  border-radius 30px
  margin 10px
  padding 20px
  background $color__background-board--default
  .dark-theme &
    background $color__background-board--dark-theme
  &__header
    text-align center
    padding 10px 40px
    margin-bottom 20px
    box-sizing border-box
    box-shadow 0px 4px 4px rgba(0, 0, 0, 0.5)
    border-radius 30px
    font-size 30px
    font-weight bold
    background $color__background-board-top--default
    .dark-theme &
      background $color__background-board-top--dark-theme
.float-right
  float right
.exit-room-icon
  color $color__background--default
  .dark-theme &
      color $color__background--dark-theme
</style>